import { getDisplayNames } from './getDisplayNames';

export const getCountryDisplayName = (country: string, lang: string) => {
  const countryCode = country?.split('-')?.length > 1 ? country?.split('-')?.[1] : country ?? '';
  return getDisplayNames(lang)?.of(countryCode);
};
